/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u2m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applying the 2-minute rule — if a task takes under two minutes, finish it now instead of postponing it.`)
};

const es_timer_u2m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar la regla de los 2 minutos — si una tarea toma menos de dos minutos, termínala ahora en lugar de posponerla.`)
};

const de_timer_u2m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die 2-Minuten-Regel anwenden — dauert eine Aufgabe unter zwei Minuten, erledige sie jetzt, statt sie aufzuschieben.`)
};

const nl_timer_u2m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 2-minutenregel toepassen — als een taak minder dan twee minuten kost, maak je hem nu af in plaats van hem uit te stellen.`)
};

const fr_timer_u2m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer la règle des 2 minutes — si une tâche prend moins de deux minutes, terminez-la maintenant plutôt que de la reporter.`)
};

const it_timer_u2m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applicare la regola dei 2 minuti — se un compito richiede meno di due minuti, portalo a termine subito invece di rimandarlo.`)
};

const pt_br2_timer_u2m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar a regra dos 2 minutos — se uma tarefa leva menos de dois minutos, termine-a agora em vez de adiá-la.`)
};

const pt_timer_u2m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar a regra dos 2 minutos — se uma tarefa demora menos de dois minutos, termine-a agora em vez de a adiar.`)
};

const ja_timer_u2m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2分ルールを実践する — 2分未満で終わるタスクは先延ばしにせず今すぐ終わらせる。`)
};

const zh_timer_u2m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用两分钟法则 — 如果一件事花费不到两分钟，现在就完成它，而不是拖延。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u2m_use3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u2m_use3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u2m_use3", locale)
	if (locale === "en") return en_timer_u2m_use3(inputs)
	if (locale === "es") return es_timer_u2m_use3(inputs)
	if (locale === "de") return de_timer_u2m_use3(inputs)
	if (locale === "nl") return nl_timer_u2m_use3(inputs)
	if (locale === "fr") return fr_timer_u2m_use3(inputs)
	if (locale === "it") return it_timer_u2m_use3(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u2m_use3(inputs)
	if (locale === "pt") return pt_timer_u2m_use3(inputs)
	if (locale === "ja") return ja_timer_u2m_use3(inputs)
	return zh_timer_u2m_use3(inputs)
};